
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as shopWcnKVmGN2OGa5Rr_45bNSycKTZpWSWs_CsosYyijEUh84Meta } from "/home/unwar190/web/underwar.org/public_html/pages/shop.vue?macro=true";
import { default as indexKn1Uui1I3OR6j73EBcqwDX88N58XqezVHKDw1LRl_k0Meta } from "/home/unwar190/web/underwar.org/public_html/pages/index.vue?macro=true";
import { default as checkoutafy1_45lzXZrf6gWZ33mT_r3fnRQe5PwybbTbs7pt1dQwMeta } from "/home/unwar190/web/underwar.org/public_html/pages/checkout.vue?macro=true";
import { default as downloadSFfQR4_45VfDxKLJ5PZF3fTA1wQIRg3dVGhXFAyXg_hTcMeta } from "/home/unwar190/web/underwar.org/public_html/pages/download.vue?macro=true";
import { default as noticiashLMNzcOREY77G6CRGBha22QCmYT_4522_szBY8WWqqZQ4Meta } from "/home/unwar190/web/underwar.org/public_html/pages/noticias.vue?macro=true";
import { default as loginGTqpclKY3BNg6_j85ZA7AEyeX3MyfZy1sG2HRcMdVq4Meta } from "/home/unwar190/web/underwar.org/public_html/pages/auth/login.vue?macro=true";
import { default as _91slug_93zeyd_FTHWQDqYSenqEIcBfLlk7iX6DOQjs4C70Wu2rkMeta } from "/home/unwar190/web/underwar.org/public_html/pages/page/[slug].vue?macro=true";
import { default as _91slug_93D_4QA_PUDfRVTPQUW06HI_45bibM0j8w0HelGKVzwaKMcMeta } from "/home/unwar190/web/underwar.org/public_html/pages/post/[slug].vue?macro=true";
import { default as recoverwnZlLqT_45pgyZ_TlFxVpr6ASZ_45_S8SZem8syZYe_SV50Meta } from "/home/unwar190/web/underwar.org/public_html/pages/auth/recover.vue?macro=true";
import { default as _91slug_93JebIvr_jU8IjmpCq8g2c0FKGL7OPuTVcbpSn3gVWt_wMeta } from "/home/unwar190/web/underwar.org/public_html/pages/guild/[slug].vue?macro=true";
import { default as indexq2tnRuRYoKpQtQuFrDlae_45ClO3_45DFjNmnsECj0hs41YMeta } from "/home/unwar190/web/underwar.org/public_html/pages/guilds/index.vue?macro=true";
import { default as indexFYxiiE5jckUnr7CjSUR9PUbvX9HqWQYRhjlGNjT8UJEMeta } from "/home/unwar190/web/underwar.org/public_html/pages/online/index.vue?macro=true";
import { default as indexpmfT4v4YgxoYC0bTPvtWaCyjFtuz_7O6wsy7PVo3oOIMeta } from "/home/unwar190/web/underwar.org/public_html/pages/account/index.vue?macro=true";
import { default as registerA8UMlMojBE6qu0tYBhj0eno0_Fp0U4PeucM6fBSNhgoMeta } from "/home/unwar190/web/underwar.org/public_html/pages/auth/register.vue?macro=true";
import { default as daily_45rewardso6uY83qoMiHPnTd5BN35QUjS0jd5RjS9CrMVXjrFXf0Meta } from "/home/unwar190/web/underwar.org/public_html/pages/daily-rewards.vue?macro=true";
import { default as supportz4_45SGUZ9lcCAWc78mNupFDFNoeWXWWF7n5f8vzlHi_kMeta } from "/home/unwar190/web/underwar.org/public_html/pages/account/support.vue?macro=true";
import { default as _91slug_932Arg12SFxn9x1JmHPY1d6ZHPyFuAE6RT0xmul3O1pU4Meta } from "/home/unwar190/web/underwar.org/public_html/pages/character/[slug].vue?macro=true";
import { default as searchRMJ_G6uTeEch8am3_456u3_451WMiWMOP_459ejBnTtDgNGegMeta } from "/home/unwar190/web/underwar.org/public_html/pages/character/search.vue?macro=true";
import { default as indexn0csSZC_vIrTMlnoaqpZN35IzhFK3YXGH_496zFLGzEMeta } from "/home/unwar190/web/underwar.org/public_html/pages/highscores/index.vue?macro=true";
import { default as indexSmI36_45Y7sB_p75GA7g_F2fwYrQzfp08P76s7bHOMSPQMeta } from "/home/unwar190/web/underwar.org/public_html/pages/latest-kills/index.vue?macro=true";
import { default as reset_45passwordYWhG8vqEQyxT0jIL_452lPboOL87VmCvOvn3eVhfXLvZAMeta } from "/home/unwar190/web/underwar.org/public_html/pages/auth/reset-password.vue?macro=true";
import { default as buy_charactergKlryhdyQdc0C3u1jIPtukcR1OLKJhafHL06cTw5thIMeta } from "/home/unwar190/web/underwar.org/public_html/pages/account/buy_character.vue?macro=true";
import { default as sell_characterPvq5c_4xqOu_45ewRG2NKepzCLl4uamG1O8XJYAULn3woMeta } from "/home/unwar190/web/underwar.org/public_html/pages/account/sell_character.vue?macro=true";
import { default as create_characterz_xtPaVxkMw1tpoKBhE07W98fzOo5I1Aqyf2cycdpSEMeta } from "/home/unwar190/web/underwar.org/public_html/pages/account/create_character.vue?macro=true";
import { default as _91type_938L5RffNSNQj8DoLv4rd1Iw1H1jebDkBAKY_45iJU6N9tIMeta } from "/home/unwar190/web/underwar.org/public_html/pages/account/transactions/[type].vue?macro=true";
export default [
  {
    name: "shop",
    path: "/shop",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/shop.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/checkout.vue")
  },
  {
    name: "download",
    path: "/download",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/download.vue")
  },
  {
    name: "noticias",
    path: "/noticias",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/noticias.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: {"middleware":"is-logged-in"},
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/auth/login.vue")
  },
  {
    name: "page-slug",
    path: "/page/:slug()",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/page/[slug].vue")
  },
  {
    name: "post-slug",
    path: "/post/:slug()",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/post/[slug].vue")
  },
  {
    name: "auth-recover",
    path: "/auth/recover",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/auth/recover.vue")
  },
  {
    name: "guild-slug",
    path: "/guild/:slug()",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/guild/[slug].vue")
  },
  {
    name: "guilds",
    path: "/guilds",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/guilds/index.vue")
  },
  {
    name: "online",
    path: "/online",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/online/index.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/account/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/auth/register.vue")
  },
  {
    name: "daily-rewards",
    path: "/daily-rewards",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/daily-rewards.vue")
  },
  {
    name: "account-support",
    path: "/account/support",
    meta: {"middleware":["is-logged-out"]},
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/account/support.vue")
  },
  {
    name: "character-slug",
    path: "/character/:slug()",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/character/[slug].vue")
  },
  {
    name: "character-search",
    path: "/character/search",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/character/search.vue")
  },
  {
    name: "highscores",
    path: "/highscores",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/highscores/index.vue")
  },
  {
    name: "latest-kills",
    path: "/latest-kills",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/latest-kills/index.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/auth/reset-password.vue")
  },
  {
    name: "account-buy_character",
    path: "/account/buy_character",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/account/buy_character.vue")
  },
  {
    name: "account-sell_character",
    path: "/account/sell_character",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/account/sell_character.vue")
  },
  {
    name: "account-create_character",
    path: "/account/create_character",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/account/create_character.vue")
  },
  {
    name: "account-transactions-type",
    path: "/account/transactions/:type()",
    component: () => import("/home/unwar190/web/underwar.org/public_html/pages/account/transactions/[type].vue")
  }
]